module.exports = __webpack_public_path__ + "img/d-auto-zh.de30eb45.png";